var map = {
	"./Andre_Marquet.jpg": 118,
	"./Andrea_Campagnoli.jpg": 119,
	"./Angelika_Morongova.jpg": 120,
	"./Daniel_Zacarias.jpg": 121,
	"./Elena_Tisato.jpg": 122,
	"./Filipa_Ferreira.jpg": 123,
	"./Joao_Bernardino.jpg": 124,
	"./Joao_Filipe.jpg": 125,
	"./Maria_Pereira.jpg": 126,
	"./Patricia_Travessa.jpeg": 127,
	"./Paulo_Gaudencio.jpeg": 128,
	"./Rafael_Daron.jpg": 129,
	"./Sara_Cerqueira.jpeg": 130,
	"./TeamEmailIcon.png": 49,
	"./TeamLinkedinIcon.png": 47,
	"./TeamTwitterIcon.png": 48,
	"./Teresa_Segismundo.jpg": 131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 117;